var _symbol, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "-12.1 -12.6 24.2 25.1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4,1.2c-1.6,0-2.8,0.3-3.6,0.8C-4,2.5-4.4,3.3-4.4,4.4c0,1,0.3,1.7,1,2.3c0.6,0.5,1.5,0.8,2.7,0.8c1.4,0,2.6-0.5,3.6-1.5 c1-1,1.5-2.3,1.5-3.9V1.2L0.4,1.2z M12.1-1.7v13.7H4.4V8.4c-1,1.4-2.2,2.5-3.5,3.2c-1.3,0.7-2.8,1-4.7,1c-2.5,0-4.5-0.7-6-2.2 c-1.5-1.4-2.3-3.3-2.3-5.6c0-2.8,1-4.9,2.9-6.2c1.9-1.3,5-2,9.1-2h4.5V-4c0-1.2-0.5-2.1-1.4-2.7C2-7.2,0.5-7.5-1.5-7.5 c-1.6,0-3.2,0.2-4.6,0.5C-7.5-6.7-8.8-6.2-10-5.5v-5.8c1.6-0.4,3.3-0.7,4.9-0.9c1.7-0.2,3.3-0.3,5-0.3c4.3,0,7.4,0.9,9.3,2.6 C11.1-8.3,12.1-5.5,12.1-1.7L12.1-1.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.7,375.6h10.7c3.4,0.1,6.8-0.6,9.9-2c3.6-1.6,6.7-4.3,8.8-7.7c2.1-3.5,3.1-7.6,3.1-11.6c0.2-6.4-2.4-12.6-7.3-16.8 c-4.7-3.7-10.6-5.5-16.6-5.1h-22.9v70H216L215.7,375.6z M215.7,345.8h8.2c6.4,0,9.6,2.7,9.6,8.1c0.1,2.5-0.8,4.9-2.5,6.6 c-2,1.7-4.5,2.6-7.1,2.4h-8.2V345.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.8,398.6c5.2-2.9,9.5-7.4,12.2-12.7c2.9-5.7,4.4-12,4.4-18.5c0.6-11.1-4.1-21.8-12.6-28.9c-5.1-4.1-11.5-6.3-18-6.1 h-26.2v70h21.4C290.4,402.8,296.9,401.5,302.8,398.6L302.8,398.6z M276.5,346.1h9.8c3.3-0.1,6.6,0.8,9.4,2.5 c5.8,4.3,8.9,11.3,8.3,18.6c0.7,7.7-2.6,15.2-8.8,19.8c-2.9,1.8-6.2,2.7-9.5,2.5h-8.9L276.5,346.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349.4,373.5h23.2v-13.4h-23.2v-14.3h25.3v-13.3h-40.1v70h14.8V373.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M559.4,163.4v-0.8c-0.4-0.9-1-1.8-1.7-2.5L435.2,37.5c-0.7-0.7-1.6-1.3-2.5-1.7h-0.8c-0.8-0.4-1.7-0.7-2.6-0.9H183.8 c-4.8,0-8.8,3.9-8.8,8.8V280h-26.2c-4.8,0-8.8,3.9-8.8,8.8v157.5c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6H175v61.2 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h367.5c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2v-350v-0.5 C559.9,164.9,559.7,164.1,559.4,163.4L559.4,163.4z M437.5,64.8l92.7,92.7h-92.7V64.8z M157.5,297.5H420v140H157.5V297.5z  M192.5,507.5V455h236.2c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2V288.7c0-2.3-0.9-4.5-2.6-6.2s-3.9-2.6-6.2-2.6H192.5V52.5H420v113.8 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h113.8v332.5H192.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 687.8,
    y: 691.2,
    width: 700,
    height: 700
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105427052614592896650000007288996127537051054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105427052614592896650000007288996127537051054_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 24.2,
    height: 25.1,
    x: -12.1,
    y: -12.6,
    transform: "matrix(1 0 0 1 701.7313 679.3119)",
    style: {
      overflow: "visible"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.f1149c637d27508efc946a5ee308ca58.svg";
export { ForwardRef as ReactComponent };